module.exports = __webpack_public_path__ + "static/img/invalid_cn.985fe66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sdk/invalid_cn.png
// module id = 1412
// module chunks = 1